import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AllocationViewDropAllocationAction,
  AllocationViewDropAllocationActionSetInitialState,
} from './allocation-view-drop-allocation-action.actions';
import { AllocationViewDropAllocationActionService } from './allocation-view-drop-allocation-action.service';
import { NotificationService } from '../../../../../../common';
import { Injectable } from '@angular/core';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewDropAllocationActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewDropAllocationActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsDropAllocation',
  defaults: initialState,
})
@Injectable()
export class AllocationViewDropAllocationActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewDropAllocationActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewDropAllocationActionService: AllocationViewDropAllocationActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewDropAllocationAction)
  dropAllocation(
    ctx: StateContext<AllocationViewDropAllocationActionStateModel>,
    { payload: { identifier } }: AllocationViewDropAllocationAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewDropAllocationActionService.dropAllocation(identifier).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.drop');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewDropAllocationActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewDropAllocationActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
